import { Flex } from '@chakra-ui/react'

export function TabMobile({ children }) {
  return (
    <Flex width="100%" direction="column">
      {children}
    </Flex>
  )
}
